import {KTImage} from 'helpers/ui-components/KTImage'
import React from 'react'

type Props = {
 className?: string
 imageUrl: string
 imageAlt?: string
 buttonText?: string
 buttonLink?: string
 onClick?:
  | ((event: React.MouseEvent<HTMLButtonElement>) => void)
  | undefined
}

export function LinkCard(props: Props) {
 return (
  <div className='m-[12px] relative text-center w-[260px] h-[215px] p-3 border border-[#E6EBF0] rounded-xl'>
   <div className='flex justify-center items-center text-center rounded-xl w-[235px] h-[140px] bg-[#F5F8FA]'>
    <KTImage
     className={'max-w-[80px] max-h-[80px]'}
     src={props.imageUrl}
     alt={props.imageAlt}
    />
   </div>
   <button
    className='w-full text-lg font-medium text-[#4D4D4D] text-center pt-4 cursor-pointer bg-white rounded-b-[20px]'
    onClick={props.onClick}
   >
    {props.buttonText}
   </button>
  </div>
 )
}

LinkCard.defaultProps = {
 className: 'w-4 h-4',
}
